import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import classes from '../Assist.css';

import { useMobile, authEndpoint, alertErrors } from '../../../store/utility';
import axios from 'axios';
import Alert from 'react-s-alert';

class RequestPasswordReset extends React.Component{

    constructor(props) {
        super(props);
        /* 1. Initialize Input Ref */
        this.emailInput = React.createRef(); 
    }

    handleRequest = () => {
        let url = authEndpoint + 'api/v1/rest-auth/password/reset/';
            let requestPasswordResetData = {
                email: this.emailInput.current.value,
            }
            axios.post(url, requestPasswordResetData)
                .then(response => {
                    Alert.success(response.data.detail);
                })
                .catch(err => {
                    alertErrors(err);
        });
    }

    handleHadCode = () => {
        Alert.info("Please check your email, and click the password reset link in the email");
    }

    render(){

        let displaySize;
        if (useMobile()===true) {
            displaySize = 'none';
        }
        else {
            displaySize = 'none';
        }

        return (

            <div className={classes.Assist}>
                <Container>
                <Form>
                    <Row>
                        <Col>
                            <Form.Group controlId="email">
                                <Form.Label><b>Email</b></Form.Label>
                                <Form.Control ref={this.emailInput} size={displaySize}  
                                    type="email" placeholder="email" defaultValue={this.props.email}/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} md={12}>
                            <div className={classes.Button}>
                            <Button variant="info" size={displaySize} onClick={this.handleRequest} block>Send Code</Button>
                            </div>
                        </Col>
                        <Col lg={6} md={12}>
                            <div className={classes.Button}>
                            <Button variant="outline-info" size={displaySize} onClick={this.handleHadCode} block>Have a Code</Button>
                            </div>
                        </Col>
                    </Row>
                    </Form>
                </Container>
            </div>
        );
    }
}

export default RequestPasswordReset;


// WEBPACK FOOTER //
// ./src/containers/Assist/RequestPasswordReset/RequestPasswordReset.js